import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { getPageUrl } from 'app/modules/shared/routing'
import { trackEvent } from 'app/modules/shared/helpers'
import AppbarDropdown from './appbar-dropdown'
import { getActiveSubRouteClass } from './helpers/helpers'

const AETHER_ROUTE = 'upgrade-to-metadefender-aether'
const METADEFENDER_CLOUD_URL = 'https://metadefender.com'

// Commercial product entry points (Aether upgrade, MetaDefender Cloud) in one
// dropdown, kept apart from the community items.
const Enterprise = (): JSX.Element => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)

  const getActiveMenuClass = (route: string) =>
    getActiveSubRouteClass([route], currentRoute, 'appbar-dropdown-item-selected')

  return (
    <AppbarDropdown
      className={getActiveSubRouteClass([AETHER_ROUTE], currentRoute, 'appbar-dropdown-selected')}
      title={_t('enterprise')}
    >
      <Link
        className={`dropdown-item ${getActiveMenuClass(AETHER_ROUTE)}`}
        to={getPageUrl('aether-upgrade') as string}
        onClick={() => trackEvent({ event: 'aether_upgrade_cta', cta_source: 'appbar-enterprise' })}
      >
        {_t('metadefender-aether')}
      </Link>
      <a className="dropdown-item" href={METADEFENDER_CLOUD_URL} target="_blank" rel="noreferrer">
        {_t('metadefender-cloud')}
      </a>
    </AppbarDropdown>
  )
}

export default Enterprise
